export default {
    url: '/version',
    template: '<ui-view></ui-view>',
    resolve: {
        course ($stateParams, CourseResource, CourseService) {
            return CourseResource.get({
                id: $stateParams.id,
                expand: 'fields,courseFields,courseTrainings.scormTrainings.scorm,activeI18n,courseI18ns,courseTrainingI18ns,courseVersions,' +
                    'courseTrainingForms,sites,events,courseTrainings.materials,courseTrainings.materials.languages,' +
                    'courseTrainings.materials.chapters.chapterI18ns,' +
                    'courseTrainings.materials.chapters.section.sectionI18ns'
            }).$promise.then((course) => {
                CourseService.nestCompositeModels(course);
                return course;
            });
        }
    },
    abstract: true,
    controller ($scope, course) {
        $scope.$parent.vm.step = 3;
        $scope.$parent.vm.course = course;
        $scope.$parent.vm.isArchived = course.isArchived;
        $scope.$on('archiveChange', (event, { isArchived }) => {
            $scope.$parent.vm.isArchived = isArchived;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/version/index.js